import { Button, DialogActions, DialogContent } from '@mui/material'
import { FC, useContext, useMemo } from 'react'

import useAccessTokenAndShopId from '../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { useGetTimeClockWithRelated } from '../../hooks/useGetTimeClockWithRelated/useGetTimeClockWithRelated'
import { AppContext } from '../../providers/AppProvider/AppProvider'
import { useListRepairOrdersWithRelatedQuery } from '../../redux/api'
import { TimeClockEntry } from '../../sdk'
import { UpdateTimeClockForm } from '../TimeClockCard/UpdateTimeClockForm'

interface Props {
  onClose: () => void
  entry: TimeClockEntry
  timeClocks: TimeClockEntry[]
}

export const UpdateTimeClockDialog: FC<Props> = ({
  onClose,
  entry,
  timeClocks
}) => {
  const { accessToken, shopId } = useAccessTokenAndShopId()
  const timeClocksWithRelated = useGetTimeClockWithRelated([entry])
  const timeClockWithRelated = useMemo(
    () => timeClocksWithRelated && timeClocksWithRelated[0],
    [timeClocksWithRelated]
  )
  const { productivityStatuses } = useContext(AppContext)
  const { data: recentRepairOrders } = useListRepairOrdersWithRelatedQuery({
    authorization: accessToken,
    shop: shopId,
    isEstimate: false,
    isRecent: true
  })
  const nextTimeClock = useMemo(() => {
    const index = timeClocks.findIndex((t) => t.id === entry.id)
    if (index < 1) {
      return
    }
    return timeClocks[index - 1]
  }, [entry.id, timeClocks])
  const lastTimeClock = useMemo(() => {
    const index = timeClocks.findIndex((t) => t.id === entry.id)
    if (index === timeClocks.length - 1) {
      return
    }
    return timeClocks[index + 1]
  }, [entry.id, timeClocks])

  return (
    <>
      <DialogContent>
        {productivityStatuses && recentRepairOrders && timeClockWithRelated && (
          <UpdateTimeClockForm
            {...{
              timeClockWithRelated,
              lastTimeClock,
              nextTimeClock,
              productivityStatuses,
              recentRepairOrders
            }}
            submitCallback={onClose}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button type="submit" form="updateTimeClock">
          Confirm
        </Button>
      </DialogActions>
    </>
  )
}
